import React, {useState, useEffect} from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import {connect} from "react-redux";
import PropTypes from "prop-types";

const ButtonGroup = (props) => {

  const {children, buttons, activeButtonIndex, setActiveButtonIndex, dropDownHeight} = props
  const [dropdownOpened, setDropdownOpened] = useState(false);
  const [dropdownOpenedFirstTime, setDropdownOpenedFirstTime] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleButtonClick = (buttonIndex) => {
    setActiveButtonIndex(buttonIndex);
    buttons[buttonIndex].clickFunction()
    setDropdownOpened(false);
  }

  const handleArrowClick = () => {
    setDropdownOpened(!dropdownOpened);
    setDropdownOpenedFirstTime(true)
  }

  const handleActiveButtonClick = () => {
    if (!dropdownOpenedFirstTime && !dropdownOpened) {
      handleArrowClick();
      return false;
    }
    buttons[activeButtonIndex].clickFunction();
  }

  const styles = {
    height: dropdownOpened ? dropDownHeight + "px" : 0
  };

  return (
    <div className={"ui-group" + (dropdownOpened ? " ui-group--opened" : "")}>
      {buttons[activeButtonIndex].element}
      <button className="ui-button2 ui-button2--green" onClick={handleActiveButtonClick}>
        <FormattedMessage id={buttons[activeButtonIndex].intlText}/>
      </button>
      <button className="ui-group__button"
              onClick={handleArrowClick}/>
      <div className="ui-group__dropdown" style={styles}>
        {buttons.map((button, buttonIndex) => {
          return (
            <button className="ui-button2 ui-button2--green" onClick={() => handleButtonClick(buttonIndex)} key={buttonIndex}>
              <FormattedMessage id={button.intlText}/>
            </button>
          )
        })}
        {children}
      </div>
      <span className="ui-group__triangle"/>
    </div>
  )
};

ButtonGroup.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  activeButtonIndex: PropTypes.number.isRequired,
  setActiveButtonIndex: PropTypes.func.isRequired,
  buttons: PropTypes.array.isRequired,
  dropDownHeight: PropTypes.number.isRequired,
};

const mapStateToProps = (store) => {
  return {
    assignQuotePopupSearchText: store.assignQuoteState.assignQuotePopupSearchText,
    windowWidth: store.serverState.windowWidth,
  };
};

const mapDispatchToProps = {

};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(ButtonGroup)
)
